import React from "react";

const SectionTitle = ({ text }: { text: string }) => {
  return (
    <h3 className="text-lg font-semibold text-gray-700 tracking-wide">
      {text}
    </h3>
  );
};

export default SectionTitle;
